export const divider = ({ theme: { colors } }) => ({
    width: '100%',
    height: '1px',
    backgroundColor: colors.blueGrey1,
    overflow: 'hidden',
    margin: '40px 0',
});
